import { ConfirmDelete } from "../../../../../common/components/modal/confirmDelete/confirmDelete";

export const DeleteGoalsModal = ({
  goal,
  open,
  loading,
  closeModal,
  onDelete,
}) => {
  return (
    <ConfirmDelete
      open={open}
      closeModal={closeModal}
      onConfirm={onDelete}
      loading={loading}
    >
      The goals configuration will be deleted for this client:{" "}
      <strong>{goal?.clientName}</strong>.
    </ConfirmDelete>
  );
};
